import { normalizeWidgetTheme, APIURL, appendFlatpickrBaseStyles, initFlatpickrInShadow, cancelSelectEvent, changeSymbolForWidget, getCSSStyles, getNoDataHTML, getSymbolDropdown, getTraderSMCardHTML, getWidgetDataURI, isEmptyWidgetData, apiGet, toggleWidgetTheme, updateSelectedSymbolInDropdown, isHeaderPinned, getHeaderPinStateClass, getHeaderPinButtonHTML, setupHeaderPin } from './../../helpers';
import { WidgetConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from './../../types';
import flatpickr from 'flatpickr';
import { format } from 'date-fns';

export class TraderverseUpgradesDowngrades {
  private container: HTMLElement;
  private config: WidgetConfig;
  private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
  private updateInterval: number | null = null;
  private shadowRoot: ShadowRoot;
  private currentData: any = null;
  private widgetResizeObserver: ResizeObserver | null = null;
  private selectedRange: string = 'Last 3 Months';
  private startDate: string | null = null;
  private endDate: string | null = null;
  private calendarInstance: any = null;
  private selectedAction: string = 'all';
  private widgetIndex: number = 0;

  constructor(config: WidgetConfig) {
    this.config = { ...this.getDefaultConfig(), ...config };
    this.config.theme = normalizeWidgetTheme(this.config.theme);
    this.container = this.resolveContainer(config.container);

    if ((this.container as any).shadowRoot) {
      this.shadowRoot = (this.container as any).shadowRoot;
    } else {
      this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
    }
    this.init();

    this.widgetResizeObserver = new ResizeObserver(() => {
      this.updateDisplay();
    });
    setTimeout(() => {
      const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
      if (widget) this.widgetResizeObserver?.observe(widget);
    }, 0);
  }

  private fetchSymbols(): Array<{ value: string; label: string }> {
    return [
      { label: 'AAPL', value: 'AAPL' }, { label: 'MSFT', value: 'MSFT' },
      { label: 'GOOGL', value: 'GOOGL' }, { label: 'AMZN', value: 'AMZN' },
      { label: 'NVDA', value: 'NVDA' }, { label: 'META', value: 'META' },
      { label: 'TSLA', value: 'TSLA' }, { label: 'AVGO', value: 'AVGO' },
      { label: 'PEP', value: 'PEP' }, { label: 'COST', value: 'COST' }
    ];
  }

  private getDefaultConfig(): Partial<WidgetConfig> {
    const symbols = this.fetchSymbols();
    return {
      headerPinned: true,
      symbol: symbols[0].value,
      theme: 'default-dark',
      width: '100%',
      height: '400px',
      autosize: true
    };
  }

  private resolveContainer(container: string | HTMLElement): HTMLElement {
    if (typeof container === 'string') {
      const el = document.getElementById(container) || document.querySelector(container);
      if (!el) throw new Error(`Container not found: ${container}`);
      return el as HTMLElement;
    }
    return container;
  }

  private async init(): Promise<void> {
    if (!this.config.symbol) this.config.symbol = this.fetchSymbols()[0].value;
    await this.injectChartLibrary();
    this.createWidget();
    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    if (widget) widget.classList.add('loading');
    this.setDateRange(this.selectedRange);
    this.attachStyles();
    this.setupEventListeners();
    await this.setupChart(this.config.symbol!);
    if (widget) widget.classList.remove('loading');
    this.setupCalendar();
    this.emit('ready', {});
    cancelSelectEvent(this.shadowRoot);
    this.config.onReady?.();
  }

  
  private setDateRange(range: string): void {
    const today = new Date();
    let start = new Date();

    switch (range) {
      case 'Current Week':
        start.setDate(today.getDate() - today.getDay());
        break;
      case 'Last Week':
        start.setDate(today.getDate() - today.getDay() - 7);
        today.setDate(start.getDate() + 6);
        break;
      case 'Last 2 Weeks':
        start.setDate(today.getDate() - 14);
        break;
      case 'Last 3 Months':
        start.setMonth(today.getMonth() - 3);
        break;
      case 'This Month':
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        break;
      default:
        start.setMonth(today.getMonth() - 1);
        break;
    }

    this.startDate = start.toISOString().split('T')[0];
    this.endDate = today.toISOString().split('T')[0];
  }

  private createWidget(): void {

    let themeClass = 'defaultDarkMode';
let dataTheme = 'default-dark';

if (this.config.theme === 'white') {
  themeClass = 'whiteMode';
  dataTheme = 'white';
} else if (this.config.theme === 'black') {
  themeClass = 'blackMode';
  dataTheme = 'black';
} else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}

    const widgetHtml = `
         <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-theme="${dataTheme}">
          <div class="headTop">
            <h4 class="title stock">${this.getTitleIconSvg()} Upgrades &amp; Downgrades</h4>
            <div class="actionCol">${getHeaderPinButtonHTML(this.config)}
              <div class="item">
                <button class="filters-toggle" type="button"> <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.1794 0.950592H1.72077C1.57285 0.950469 1.42802 0.991908 1.30363 1.06995C1.17925 1.14799 1.08058 1.25932 1.01944 1.39061C0.958302 1.5219 0.937286 1.66759 0.958909 1.81023C0.980533 1.95286 1.04388 2.0864 1.14136 2.19484L5.22108 6.73834C5.34378 6.8752 5.41132 7.05084 5.41114 7.23259V10.8881C5.41114 10.9463 5.42504 11.0037 5.45175 11.0558C5.47846 11.1079 5.51725 11.1532 5.56503 11.1881L7.87343 12.8756C7.93059 12.9174 7.99856 12.9428 8.06972 12.9491C8.14088 12.9553 8.21242 12.9421 8.27633 12.911C8.34023 12.8799 8.39398 12.832 8.43154 12.7727C8.46911 12.7135 8.489 12.6452 8.489 12.5756V7.23259C8.48882 7.05084 8.55636 6.8752 8.67906 6.73834L12.7588 2.19409C13.1943 1.70959 12.8403 0.950592 12.1794 0.950592Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/> </svg> </button>
              </div>
            </div>
          </div>
          <div class="inBody">
            <div class="optionsRow">
              ${this.config.hideSymbol ? '<div class="item dropStyle01"></div>' : `<div class="item dropStyle01">
                <div class="trader-sm-card" id="selected-symbol">
                  ${getTraderSMCardHTML(this.config.stock ?? { symbol: this.config.symbol!, type: "stock", name: "" })}
                </div>
                <span id="symbol-dropdown-placeholder"></span>
              </div>`}
              <span></span>


                <div class="filtersBox sideBar hidden">
                  <div class="item">
                    <select class="action-select" data-testing-id="action-select">
                      <option value="all" selected>All</option>
                      <option value="hold">Hold</option>
                      <option value="upgrade">Upgrade</option>
                      <option value="downgrade">Downgrade</option>
                      <option value="initialise">Initialise</option>
                    </select>
                  </div>

                  <div class="item">
                    <select class="range-select" data-testing-id="range-select">
                    <option value="Current Week" >Current Week</option>
                    <option value="Last Week">Last Week</option>
                    <option value="Last 2 Weeks">Last 2 Weeks</option>
                    <option value="Last 3 Months" selected>Last 3 Months</option>
                    <option value="This Month">This Month</option>
                  </select>
                  </div>
                  <div class="item">
                    <input id="calendarPicker" type="text" placeholder="Select Date Range" readonly data-testing-id="calendar-picker" />
                  </div>
                </div>

            </div>
            <div class="chartDv" id="upgradesContainer"></div>
          </div>
        </div>
    `;
    this.shadowRoot.innerHTML = widgetHtml;
    const rangeSelect = this.shadowRoot.querySelector('.range-select') as HTMLSelectElement;
    rangeSelect.addEventListener('change', () => {
      this.selectedRange = rangeSelect.value;
      this.setDateRange(this.selectedRange);
      this.setupChart(this.config.symbol!);
    });

    const actionSelect = this.shadowRoot.querySelector('.action-select') as HTMLSelectElement;
    actionSelect.addEventListener('change', () => {
      this.selectedAction = actionSelect.value;
      this.setupChart(this.config.symbol!);
    });

    const filtersToggleBtn = this.shadowRoot.querySelector('.filters-toggle') as HTMLButtonElement | null;
    const filtersBox = this.shadowRoot.querySelector('.filtersBox') as HTMLElement | null;
    if (filtersToggleBtn && filtersBox) {
      filtersToggleBtn.addEventListener('click', () => {
        filtersBox.classList.toggle('hidden');
      });
    }

    if (this.config.isSymbolSelectable && !this.config.hideSymbol) {
      const dropdown = getSymbolDropdown((data: any) => this.onSelectChange(data));
      const placeholder = this.shadowRoot.getElementById('symbol-dropdown-placeholder');
      if (placeholder && dropdown) {
        placeholder.replaceWith(dropdown);
      }
    }
  }

  onSelectChange(stock: any) {
    this.changeSymbol(stock.symbol, stock);
  }

  private setupCalendar(): void {
    const calendarInput = this.shadowRoot.querySelector('#calendarPicker') as HTMLInputElement;
    if (!calendarInput) return;

    let firstDateSelected = false;
    this.calendarInstance = initFlatpickrInShadow(calendarInput, this.shadowRoot, {
      dateFormat: 'Y-m-d',
      closeOnSelect: false,
      onChange: (selectedDates: Date[]) => {
        if (!firstDateSelected) {
          this.startDate = format(selectedDates[0], 'yyyy-MM-dd');
          firstDateSelected = true;
          calendarInput.value = `Start: ${this.startDate}`;
        } else {
          this.endDate = format(selectedDates[0], 'yyyy-MM-dd');
          firstDateSelected = false;
          calendarInput.value = `${this.startDate} to ${this.endDate}`;
          this.calendarInstance.close();
          this.fetchCustomDateRange();
        }
      },
    });
  }

  private async fetchCustomDateRange(): Promise<void> {
    if (!this.startDate || !this.endDate) return;
    const payload: any = {
      browser_detail: "Chrome",
      browser_version: "139.0.0.0",
      device: "Windows",
      start_date: this.startDate,
      end_date: this.endDate,
      entity: "markets",
      entity_type: "page",
      symbol: this.config.symbol
    };
    if (this.selectedAction && this.selectedAction !== 'all') {
      payload.action = this.selectedAction;
    }

    const response = await apiGet({
      method: "POST",
      url: `${APIURL}/v1/discover/upgrade_downgrade`,
      body: payload,
    });

    const data = await response.json();
    this.currentData = data.data || [];
    this.updateDisplay();
    this.emit('dataUpdate', this.currentData);
  }

  private async attachStyles(): Promise<void> {
    try {
      appendFlatpickrBaseStyles(this.shadowRoot);
      const styleEl = await getCSSStyles();
      this.shadowRoot.appendChild(styleEl);
    } catch (err) {
      console.error('Failed to load CSS file:', err);
    }
  }

  private setupEventListeners(): void {
    setupHeaderPin(this.shadowRoot, this.config);
    const intervalDropdown = this.shadowRoot.querySelector('.interval-dropdown') as HTMLSelectElement;
    intervalDropdown?.addEventListener('change', e => {
      const value = (e.target as HTMLSelectElement).value;
      this.setupChart(this.config.symbol!);
    });
  }

  private async injectChartLibrary(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if ((window as any).echarts) return resolve(true);
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/echarts@5/dist/echarts.min.js';
      script.async = true;
      script.onload = () => resolve(true);
      this.shadowRoot.appendChild(script);
    });
  }

  private async setupChart(symbol: string): Promise<void> {
    const widgetBox = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    const startDateStr = this.startDate ?? new Date().toISOString().split('T')[0];
    const endDateStr = this.endDate ?? new Date().toISOString().split('T')[0];

    const payload: any = {
      browser_detail: "Chrome",
      browser_version: "139.0.0.0",
      device: "Windows",
      start_date: startDateStr,
      end_date: endDateStr,
      entity: "markets",
      entity_type: "page",
      symbol: symbol
    };
    if (this.selectedAction && this.selectedAction !== 'all') {
      payload.action = this.selectedAction;
    }

    const response = await apiGet({
      method: "POST",
      url: `${APIURL}/v2/discover/upgrade_downgrade`,
      body: payload,
    });

    const data = await response.json();
    this.currentData = data.data || [];
    
    if (!this.currentData || !Array.isArray(this.currentData.data) || this.currentData.data.length === 0) {
      widgetBox?.removeAttribute('data-testing-id');
    }

    this.updateDisplay();
    this.emit('dataUpdate', this.currentData);
  }

  private updateDisplay(): void {
    const container = this.shadowRoot.querySelector('#upgradesContainer') as HTMLElement;
    if (!container) return;
    if (this.currentData == null) return;
    if (isEmptyWidgetData(this.currentData?.data)) {
      container.removeAttribute('data-testing-id');
      container.innerHTML = getNoDataHTML();
      return;
    }
    this.renderUpgradesDowngrades();
  }

  private renderUpgradesDowngrades(): void {
    const container = this.shadowRoot.querySelector('#upgradesContainer');
    const widgetBox = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    if (!container) return;
const hasData =
  Array.isArray(this.currentData?.data) &&
  this.currentData.data.length > 0;

if (hasData) {
  container.setAttribute('data-testing-id', 'upgrades-table');
} else {
  container.removeAttribute('data-testing-id');
}

    const rowsHtml = this.currentData.data.map((item: any, idx: number) => {
      let trendClass = '';
      let icon = '';
      let actionLabel = '';
      const logoUrl = `https://storage.googleapis.com/analytics-images-traderverse/stocks_v1/${item.symbol}.svg`;

      switch (item.action?.toLowerCase()) {
        case 'upgrade':
          trendClass = 'up';
          icon = `<svg fill="none" viewBox="0 0 14 14" height="14" width="14"><path d="M12.9963 3.69189V6.94189..." fill="#34E36F"/></svg>`;
          actionLabel = 'Upgrade';
          break;
        case 'downgrade':
          trendClass = 'down';
          icon = `<svg fill="none" viewBox="0 0 14 14" height="14" width="14"><path d="M12.9963 10.8203..." fill="#FF3B3B"/></svg>`;
          actionLabel = 'Downgrade';
          break;
        default:
          trendClass = 'mid';
          icon = `<svg fill="none" viewBox="0 0 6 2" height="2" width="6"><line x1="0.7" y1="1" x2="5.3" y2="1" stroke="#E2A10C" stroke-linecap="round"/></svg>`;
          actionLabel = 'Hold';
      }

      return `
        <div class="item body" data-testing-id="upgrade-downgrade-item-${idx}" data-symbol="${item.symbol || ''}" data-action="${item.action?.toLowerCase() || 'hold'}">
          <p data-testing-id="upgrade-downgrade-item-${idx}-company">${item.company || item.news_publisher || '-'}</p>
          <p data-testing-id="upgrade-downgrade-item-${idx}-previous-grade">${item.previousGrade || '-'}</p>
          <p data-testing-id="upgrade-downgrade-item-${idx}-new-grade">${item.newGrade || '-'}</p>
          <p data-testing-id="upgrade-downgrade-item-${idx}-price">${item.priceWhenPosted || '-'}</p>
          <p data-testing-id="upgrade-downgrade-item-${idx}-date">${item.publishedDate || '-'}</p>
          <p class="stat ${trendClass}" data-testing-id="upgrade-downgrade-item-${idx}-action"><span>${icon} ${actionLabel}</span></p>
        </div>
      `;
    }).join('');

    container.innerHTML = `
      <div class="upgradesDowngradesMain">
        <div class="item header">
          <p data-testing-id="header-company">Company</p>
          <p data-testing-id="header-previous-grade">Previous Grade</p>
          <p data-testing-id="header-new-grade">New Grade</p>
          <p data-testing-id="header-price">Price When Posted</p>
          <p data-testing-id="header-date">Published Date</p>
          <p data-testing-id="header-action">Action</p>
        </div>
        ${rowsHtml}
      </div>
    `;
  }

  private changeSymbol(stockId: string, stock: any = null): void {
    changeSymbolForWidget(this.shadowRoot, this.config, stock, stockId, (s: any) => this.setupChart(s), (t: any, d: any) => this.emit(t, d));
  }

  public on(type: WidgetEventType, handler: WidgetEventHandler): void {
    if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
    this.eventHandlers.get(type)!.push(handler);
  }
  
  public off(type: WidgetEventType, handler: WidgetEventHandler): void {
    const list = this.eventHandlers.get(type);
    if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
  }
  
  public setSymbol(symbol: string): void {
    this.changeSymbol(symbol);
    const dropdown = this.shadowRoot.querySelector('.symbol-dropdown') as HTMLSelectElement;
    if (dropdown) dropdown.value = symbol;
  }
  
  public async getWidgetImage(): Promise<string> {
    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    return await getWidgetDataURI(widget);
  }
  public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
  if (!this.shadowRoot) return;

  this.config.theme = toggleWidgetTheme(
    this.shadowRoot,
    theme
  ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';

  this.updateDisplay();
}
  public destroy(): void {
    if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
    if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
    this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
  }

  private emit(type: WidgetEventType, data: any): void {
    const handlers = this.eventHandlers.get(type);
    if (handlers) handlers.forEach(h => h({ type, data }));
  }
  
  private getTitleIconSvg(): string {
    return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M8.59998 23.625C8.08748 23.625 7.66248 23.2 7.66248 22.6875V20.1C7.66248 19.5875 8.08748 19.1625 8.59998 19.1625C9.11248 19.1625 9.53748 19.5875 9.53748 20.1V22.6875C9.53748 23.2125 9.11248 23.625 8.59998 23.625Z" fill="currentColor"/> <path d="M15 23.625C14.4875 23.625 14.0625 23.2 14.0625 22.6875V17.5C14.0625 16.9875 14.4875 16.5625 15 16.5625C15.5125 16.5625 15.9375 16.9875 15.9375 17.5V22.6875C15.9375 23.2125 15.5125 23.625 15 23.625Z" fill="currentColor"/> <path d="M21.4 23.625C20.8875 23.625 20.4625 23.2 20.4625 22.6875V14.9125C20.4625 14.4 20.8875 13.975 21.4 13.975C21.9125 13.975 22.3375 14.4 22.3375 14.9125V22.6875C22.3375 23.2125 21.925 23.625 21.4 23.625Z" fill="currentColor"/> <path d="M8.59997 16.475C8.17497 16.475 7.79997 16.1875 7.68747 15.7625C7.56247 15.2625 7.86247 14.75 8.37497 14.625C12.975 13.475 17.025 10.9625 20.1125 7.37502L20.6875 6.70002C21.025 6.31252 21.6125 6.26252 22.0125 6.60002C22.4 6.93752 22.45 7.52502 22.1125 7.92502L21.5375 8.60002C18.2 12.5 13.8 15.2125 8.82497 16.45C8.74997 16.475 8.67497 16.475 8.59997 16.475Z" fill="currentColor"/> <path d="M21.4001 11.9C20.8876 11.9 20.4626 11.475 20.4626 10.9625V8.25H17.7375C17.225 8.25 16.8 7.825 16.8 7.3125C16.8 6.8 17.225 6.375 17.7375 6.375H21.4001C21.9126 6.375 22.3376 6.8 22.3376 7.3125V10.975C22.3376 11.4875 21.9251 11.9 21.4001 11.9Z" fill="currentColor"/> <path d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z" fill="currentColor"/> </svg>`;
  }
}

declare global { interface Window { TraderverseUpgradesDowngrades: typeof TraderverseUpgradesDowngrades; } }
if (typeof window !== 'undefined') window.TraderverseUpgradesDowngrades = TraderverseUpgradesDowngrades;